import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { DrrHttpClient } from '../../http/drr-http-client'
import { LocationCode } from '../location/location.types'
import { ServiceAvailabilitySchema } from './advisories.model'
import { ServiceAvailability } from './advisories.types'

export interface ServiceAvailabilityParams {
  clubCode: string
  breakdownLatitude: number
  breakdownLongitude: number
  locationCode: LocationCode
  zipCode: string // TODO: remove zipCode once all clubs have migrated to the DRR Club Config tool
}

@Injectable({
  providedIn: 'root',
})
export class AdvisoriesService {
  constructor(private httpClient: DrrHttpClient) {}

  getServiceAvailability$(params: ServiceAvailabilityParams): Observable<ServiceAvailability> {
    return this.httpClient
      .get<ServiceAvailability>(`/bff/club/${params.clubCode}/service-availability`, {
        params: {
          fields: 'drr,towLimit',
          breakdownLatitude: String(params.breakdownLatitude),
          breakdownLongitude: String(params.breakdownLongitude),
          locationCode: params.locationCode,
          zipCode: params.zipCode,
        },
      })
      .pipe(tap((response) => ServiceAvailabilitySchema.validateSync(response)))
  }
}
